import React from 'react';
import { Button, Modal, Typography } from 'antd';

const { Paragraph, Text, Title } = Typography;

interface RequotePartRemovalModalProps {
    open: boolean;
    isStaffRequote: boolean;
    onCancel: () => void;
    onRemove: () => void;
    onReplaceFiles: () => void;
}

export const RequotePartRemovalModal = ({
    open,
    isStaffRequote,
    onCancel,
    onRemove,
    onReplaceFiles,
}: RequotePartRemovalModalProps) => {
    if (!isStaffRequote) {
        return (
            <Modal
                centered
                closable={false}
                okText="Remove"
                okType="danger"
                onCancel={onCancel}
                onOk={onRemove}
                open={open}
                width={400}
            >
                <Title level={4}>Remove Item From Quote?</Title>
            </Modal>
        );
    }

    return (
        <Modal
            centered
            closable={false}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button danger key="remove" onClick={onRemove}>
                    Remove Part
                </Button>,
                <Button key="replace" type="primary" onClick={onReplaceFiles}>
                    Replace Drawing / Update Files
                </Button>,
            ]}
            onCancel={onCancel}
            open={open}
            width={520}
        >
            <Title level={4}>Remove or update this requote part?</Title>
            <Paragraph>
                If the customer supplied a revised drawing for this same part, update its files to retain the existing
                dimensions, machining sides, material, and finishes.
            </Paragraph>
            <Text type="secondary">
                Remove the part only when it is no longer needed. Uploading it again as a new part starts with blank
                specifications.
            </Text>
        </Modal>
    );
};
